import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { payment, paymentverify } from './api';

const initialState = {
  loading: false,
  payment_details: [],
  payment_id: '',
  paymentLoading: false,
  success: false,
  error: null
};

const actions = {
  PAYMENTWAY: 'paymentway/PAYMENTWAY',
  VERIFYAPI: 'verifyAPI/VERIFYAPI'
};

export const paymentway = createAsyncThunk(
  actions.PAYMENTWAY,
  async (payload) => {
    const response = await payment(payload);
    return response;
  }
);
// verifyAPI/VERIFYAPI
// export const verifyAPI = createAsyncThunk(
//   actions.VERIFYAPI,
//   async (payload) => {
//     const response = await paymentverify(payload);
//     return response;
//   }
// );

export const verifyAPI = createAsyncThunk(
  'payment/verifyAPI',
  async (paymentData, { rejectWithValue }) => {
    try {
      const response = await paymentverify(paymentData);
      return response.data; // Adjust based on your API's response structure
    } catch (error) {
      // Return a rejected action with the error message
      return rejectWithValue(
        error.response.data || 'Payment verification failed'
      );
    }
  }
);

export const PaymentwaySlice = createSlice({
  name: 'paymentgateway',
  initialState,
  // reducers: {},
  reducers: {
    reset: (state) => {
      state.payment_details = null;
      state.success = false;
      state.paymentLoading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(paymentway.pending, (state) => {
        state.paymentLoading = true;
        state.error = null;
      })
      .addCase(paymentway.fulfilled, (state, action) => {
        const { order, success } = action.payload;
        console.log('data', action.payload?.payment_id);
        console.log('order', order);
        state.paymentLoading = false;
        state.success = true;
        state.payment_details = order;
        state.isFetched = true;
        state.payment_id = action.payload?.payment_id;
        state.success = success;
      })
      .addCase(paymentway.rejected, (state, action) => {
        state.paymentLoading = false;
        state.success = false;
        state.payment_details = null;
        state.isFetched = true;
        state.error = action.error.message;
      });

    // ✅ Handle verifyAPI thunk
    builder
      .addCase(verifyAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyAPI.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        // You may store additional verification data if needed
      })
      .addCase(verifyAPI.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || 'Verification failed';
      });
  }
});
export const { reset } = PaymentwaySlice.actions;
export default PaymentwaySlice.reducer;
